module.exports = __webpack_public_path__ + "img/SpaceLead.3ee5f0eb.svg";